<template>
  <div>
    <div class="text-xl font-bold">Need shuttles along a particular route?</div>
    <p
      class="mt-3 font-medium"
    >Suggest a route by filling the form below and our team will get right to it.</p>
    <form class="w-full mt-8 lg:w-2/4" @submit.prevent="suggestRoute">
      <div class="flex items-center mt-6 lg:space-x-4">
        <div class="hidden w-2 h-2 transform translate-y-4 bg-active rounded-full lg:block"></div>
        <div class="w-full">
          <label class="text-xs font-medium" for="pick-up-bus-stop">Pick up bus stop</label>
          <div class="relative mt-2">
            <input
              v-model="$v.form.pickup.$model"
              type="text"
              id="pick-up-bus-stop"
              class="w-full h-12 px-3 py-4 text-xs font-medium outline-none placeholder-label-type-1 bg-gray-type-6 focus:outline-none"
            />
            <div
              class="text-xs font-bold text-red-400"
              v-if="!$v.form.pickup.required && $v.form.pickup.$error"
            >Please enter pickup bus stop</div>
          </div>
        </div>
      </div>
      <div class="flex items-center mt-6 lg:space-x-4">
        <div class="hidden w-2 h-2 transform translate-y-4 bg-red-500 rounded-full lg:block"></div>
        <div class="w-full">
          <label class="text-xs font-medium" for="destination-bus-stop">Destination bus stop</label>
          <div class="relative mt-2">
            <input
            v-model="$v.form.destination.$model"
              type="text"
              id="destination-bus-stop"
              class="w-full h-12 px-3 py-4 text-xs font-medium outline-none placeholder-label-type-1 bg-gray-type-6 focus:outline-none"
            />
            <div
              class="text-xs font-bold text-red-400"
              v-if="!$v.form.destination.required && $v.form.destination.$error"
            >Please enter destination bus stop</div>
          </div>
        </div>
      </div>
      <div class="flex items-center mt-6 lg:space-x-4">
        <div
          class="hidden w-2 h-2 transform translate-y-4 rounded-full lg:block"
          style="background-color: #5EFBF2;"
        ></div>
        <div class="flex flex-wrap w-full">
          <div class="w-full mb-6 md:w-1/2 md:mb-0">
            <label class="text-xs font-medium" for="departure_time">Departure time</label>
            <select
              v-model="$v.form.departure_time.$model"
              class="w-full h-12 px-3 py-4 text-xs font-medium outline-none placeholder-label-type-1 bg-gray-type-6 focus:outline-none"
              id="departure_time"
            >
              <option value disabled>Select departure time</option>
              <option value="12:00AM">12:00AM</option>
              <option value="01:00AM">01:00AM</option>
              <option value="02:00AM">02:00AM</option>
              <option value="03:00AM">03:00AM</option>
              <option value="04:00AM">04:00AM</option>
              <option value="05:00AM">05:00AM</option>
              <option value="06:00AM">06:00AM</option>
              <option value="07:00AM">07:00AM</option>
              <option value="08:00AM">08:00AM</option>
              <option value="09:00AM">09:00AM</option>
              <option value="10:00AM">10:00AM</option>
              <option value="11:00AM">11:00AM</option>
              <option value="12:00PM">12:00PM</option>
              <option value="01:00PM">01:00PM</option>
              <option value="02:00PM">02:00PM</option>
              <option value="03:00PM">03:00PM</option>
              <option value="04:00PM">04:00PM</option>
              <option value="05:00PM">05:00PM</option>
              <option value="06:00PM">06:00PM</option>
              <option value="07:00PM">07:00PM</option>
              <option value="08:00PM">08:00PM</option>
              <option value="09:00PM">09:00PM</option>
              <option value="10:00PM">10:00PM</option>
              <option value="11:00PM">11:00PM</option>
            </select>
            <div
              class="text-xs font-bold text-red-400"
              v-if="!$v.form.departure_time.required && $v.form.departure_time.$error"
            >Please select time of day</div>
          </div>
          <div class="w-full px-3 md:w-1/2">
            <label class="text-xs font-medium" for="trip_type">Trip type</label>
            <select
              v-model="form.trip_type"
              class="w-full h-12 px-3 py-4 text-xs font-medium outline-none placeholder-label-type-1 bg-gray-type-6 focus:outline-none"
              id="trip_type"
            >
              <option value disabled>Select trip type</option>
              <option value="one-way">One way</option>
              <option value="return">Return trip</option>
            </select>
          </div>
        </div>
      </div>
      <button
        type="submit"
        class="block w-full h-12 py-4 mt-12 font-bold text-center text-white rounded focus:outline-none"
        :class="processing ? 'bg-gray-type-7' : 'bg-active'"
        :dislabed="processing"
      >{{ processing ? 'Processing...' : 'Suggest route' }}</button>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from '@/services/axios';
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      form: {
        departure_time: "12:00PM",
        time_of_day: "",
        trip_type: "one-way",
        pickup: "",
        destination: ""
      },
      processing: false,
      errorMessage: ""
    };
  },
  validations: {
    form: {
      departure_time: {
        required
      },
      trip_type: {
        required
      },
      pickup: {
        required
      },
      destination: {
        required
      }
    }
  },
  computed: {
    ...mapGetters("auth", ["user"])
  },
  methods: {
    suggestRoute() {
      this.$v.form.$touch();

      if (this.processing || this.$v.form.$error) {
        return;
      }

      this.processing = true;

      const [departure_time, time_of_day] = this.form.departure_time.split('00');

      axios.post('/suggest', {
        ...this.form,
        departure_time,
        time_of_day,
        name: `${this.user.fname} ${this.user.lname}`,
        email: this.user.email,
        phone: this.user.phone,
      }).then(() => {
        this.$toast.success('Thank you for your suggestion!');
      }).catch(err => {
        let message = null

        if (err.response && err.response.data.message) {
          message = err.response.data.message;
        }

        this.$toast.error(message || 'An error occurred. Please try again.');
      }).then(() => this.processing = false);
    }
  }
};
</script>